// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26540693","453":"3c06dccc","455":"f607f85e","977":"62323ed8"}[chunkId] + ".chunk.js";
};